/**
 * 系统引导步骤配置。
 * selector 优先匹配页面内 data-intro / class；找不到则卡片居中显示。
 */
export const GLOBAL_INTRO_STEPS = [
  {
    title: '欢迎使用众盈物业',
    content: '首次登录可跟随引导熟悉布局。之后可随时点顶部「功能引导」重看。',
    selector: '.brand'
  },
  {
    title: '切换当前项目',
    content: '顶部「当前项目」切换物业项目，数据按项目隔离。',
    selector: '.header-right .switch-label'
  },
  {
    title: '侧边功能菜单',
    content: '左侧按业务分组进入收费、工单、扩展服务等模块。',
    selector: '.cdx-sidebar'
  },
  {
    title: '扩展服务',
    content: '养老、会所、车辆维修、员工APP、呼叫中心、工程台账等在「扩展服务」分组。',
    selector: '.menu-group-title'
  },
  {
    title: '智能客服与引导',
    content: '「众盈客服」打开 AI 客服；「功能引导」可重新触发当前页或全局引导。',
    selector: '.header-ai'
  }
];

/** 按路由 path 前缀匹配的模块引导 */
export const MODULE_INTRO_GUIDES = {
  '/elder/main': {
    key: 'elder',
    name: '养老服务',
    steps: [
      { title: '养老服务', content: '管理服务对象（老人）、巡访线路、护理分组、服务计划与上门任务。', selector: '[data-intro="elder-title"], .cdx-page-title' },
      { title: '功能页签', content: '在「养老人员 / 巡访线路 / 服务分组 / 服务计划 / 服务任务」之间切换。', selector: '[data-intro="elder-tabs"], .el-tabs' },
      { title: '新增与查询', content: '工具栏可筛选查询；右侧按钮新增人员、线路、计划或任务。', selector: '[data-intro="elder-toolbar"], .cdx-toolbar' },
      { title: '任务执行', content: '服务任务支持签到、完成登记；可记录健康状况与异常上报。', selector: '[data-intro="elder-tabs"], .el-tabs__item:last-child' }
    ]
  },
  '/club/main': {
    key: 'club',
    name: '会所管理',
    steps: [
      { title: '会所管理', content: '配置场地、审核预约、管理用品借用，并查看运营报表。', selector: '[data-intro="club-title"], .cdx-page-title' },
      { title: '预约与日历', content: '「预约管理」审核/签到签退/收退押金；「预约日历」查看场地排期。', selector: '[data-intro="club-tabs"], .el-tabs' },
      { title: '场地与收费', content: '场地可设置容量、设施、小时单价与押金标准。', selector: '[data-intro="club-toolbar"], .cdx-toolbar' },
      { title: '用品管理', content: '用品清单支持完好/损坏/维修状态，并可登记借用与归还。', selector: '[data-intro="club-tabs"], .el-tabs' }
    ]
  },
  '/vehicle/main': {
    key: 'vehicle',
    name: '车辆维修',
    steps: [
      { title: '车辆维修', content: '维护维修单位、车辆档案、配件工时、套餐与维修审批。', selector: '[data-intro="vehicle-title"], .cdx-page-title' },
      { title: '档案与标准价', content: '车辆档案含保险/年检到期；配件工时可维护零件价与工时费。', selector: '[data-intro="vehicle-tabs"], .el-tabs' },
      { title: '维修审批', content: '维修单可填写预计费用，走通过/驳回，完成后登记实际费用。', selector: '[data-intro="vehicle-tabs"], .el-tabs' },
      { title: '维修报表', content: '按车牌汇总维修频次与费用，便于年度维保分析。', selector: '[data-intro="vehicle-tabs"], .el-tabs' }
    ]
  },
  '/sms/main': {
    key: 'sms',
    name: '短信设置',
    steps: [
      { title: '短信设置', content: '配置短信平台、模板、批量发送与催费规则。', selector: '[data-intro="sms-title"], .cdx-page-title' },
      { title: '短信配置', content: '选择服务商、填写 AppID/签名，可测试发送。', selector: '[data-intro="sms-tabs"], .el-tabs' },
      { title: '模板与发送', content: '模板可插入业主姓名、金额等变量；发送记录可查历史。', selector: '[data-intro="sms-tabs"], .el-tabs' },
      { title: '短信催费', content: '按欠费天数设置催费规则，支持手动或自动催费（通道开通后生效）。', selector: '[data-intro="sms-tabs"], .el-tabs' }
    ]
  },
  '/staff-app/main': {
    key: 'staff-app',
    name: '员工APP功能配置',
    steps: [
      { title: '员工APP功能配置', content: '这里控制员工手机 APP 能看到哪些功能，不是业主端菜单。', selector: '[data-intro="staff-title"], .cdx-page-title' },
      { title: 'APP配置', content: '设置版本、强制升级、主题，以及功能模块总开关。', selector: '[data-intro="staff-tabs"], .el-tabs' },
      { title: '功能入口控制', content: '每个入口可开关、设可用角色、自定义显示名称与图标。', selector: '[data-intro="staff-tabs"], .el-tabs' },
      { title: '同步默认入口', content: '点「同步文档默认入口」可补齐住户查询、报事工单等 8 个标准功能。', selector: '[data-intro="staff-toolbar"], .cdx-toolbar' }
    ]
  },
  '/call/main': {
    key: 'call',
    name: '呼叫中心',
    steps: [
      { title: '呼叫中心', content: '登记来电、匹配业主、查看历史工单，并可一键开单。', selector: '[data-intro="call-title"], .cdx-page-title' },
      { title: '来电与未接', content: '「来电记录」处理全部来电；「未接回访」跟进未接电话。', selector: '[data-intro="call-tabs"], .el-tabs' },
      { title: '登记来电', content: '输入手机号失焦后自动匹配业主姓名与房号。', selector: '[data-intro="call-toolbar"], .cdx-toolbar' },
      { title: '详情与开单', content: '详情中可看历史工单；「开单」将来电转为报事工单。', selector: '[data-intro="call-toolbar"], .cdx-toolbar' }
    ]
  },
  '/engineering/main': {
    key: 'engineering',
    name: '工程台账',
    steps: [
      { title: '工程台账', content: '管理施工类合同、请示、材料、人工、机械、进度与清运台账。', selector: '[data-intro="eng-title"], .cdx-page-title' },
      { title: '综合与分项', content: '「工程台账」看项目总览；其它页签按类型登记明细。', selector: '[data-intro="eng-tabs"], .el-tabs' },
      { title: '字段配置', content: '可为不同台账类型自定义字段结构。', selector: '[data-intro="eng-tabs"], .el-tabs' }
    ]
  }
};

export function resolveModuleGuide(path) {
  if (!path) return null;
  const keys = Object.keys(MODULE_INTRO_GUIDES);
  const hit = keys.find(k => path === k || path.startsWith(k + '/'));
  return hit ? MODULE_INTRO_GUIDES[hit] : null;
}

export function moduleDoneKey(moduleKey) {
  return `zywy_intro_mod_${moduleKey}_v1`;
}
